<template>
  <div class="wait">
    <p class="info1 pc01">아직 세로이 업무서비스를 실행할 수 없습니다</p>
    <div class="box-type09">
      조금만 기다려주세요.
      <b>현재 세로이 서비스 신청을 진행하고 있습니다!	</b>
    </div>
    <dl>
      <dt>Q. 언제 실행할 수 있나요?</dt>
      <dd>
        <b class="check">신고대리 위탁</b>
        이 <b class="pc01 uline">요청</b> 되었을 때, 가능합니다!
      </dd>
      <dt>Q. 내 상태는 어떻게 확인하나요?</dt>
      <dd>
        <div class="txt">
          <p>세로이 상단 메뉴의 <b>"시설/서비스"</b> 를 클릭하시면,<br /><b>"서비스 신청내역"</b> 에서 확인이 가능합니다!</p>
          <img src="@/assets/img/common/img-wait.png" />
        </div>
      </dd>
    </dl>
  </div>
  <div class="layer-btn">
    <btn :txt="'다음에 하기'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'신고대리 위탁 요청하러가기'"
         :color="'purple'"
         @click="btnStmnAgncyCnsgRqt_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from "vue";
import {getUtils} from "@/utils/import";
const {$popup} = getUtils();
import StmnAgncyCnsgRqt from "@/views/my-home/stmn-agncy-cnsg-rqt.vue";

const props = defineProps({
  fcltySn: Number
});

const emits = defineEmits(['close']);

const btnCancl_click = () => {
  emits('close');
};

const btnStmnAgncyCnsgRqt_click = () => {
  const popupOpts = {
    header: '신고대리위탁요청',
    contentStyle: {
      'width': '1000px',
      'max-height': '660px',
      'overflow': 'auto',
    }
  };

  const popupProps = { fcltySn: props.fcltySn };
  const popupEmits = {'compt': btnCancl_click};

  $popup.show(StmnAgncyCnsgRqt, popupOpts, popupProps, popupEmits);
};
</script>

<style scoped>

</style>
